<template>
  <div class="d-flex justify-center">
    <v-row :class="[{'disable':loading}]">
      <v-col class="flex-auto">
        <ProductList
          :products="participantProducts.allowedProducts"
          title="Produit(s) affecté(s) au client"
          drop-element="limitedProducts"
          :width="width"
          selected="allowed"
          :customer="customer"
        />
      </v-col>
      <v-col cols="1" class="text-center d-flex align-center justify-center">
        <v-icon size="36" color="black" @click="swapProducts"> mdi-code-tags </v-icon>
      </v-col>
      <v-col class="flex-auto">
        <ProductList
          :products="participantProducts.limitedProducts"
          title="Produit que l'on peut affecter au client"
          drop-element="allowedProducts"
          :width="width"
          selected="limited"
          :customer="customer"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, onBeforeMount, computed, watch, provide } from '@vue/composition-api';
import { format } from 'date-fns';
import { updateCustomerAllowedProduct } from '../../../helpers/request';
import { sendNotification } from '../../../helpers/utils';
import ProductList from './ProductList.vue';

import store from '@/store';

export default {
  components: { ProductList },
  props: {
    customer: {
      type: Object,
      default: null
    },
    width: {
      type: String,
      default: null
    }
  },
  setup (props) {
    // const products = ref([]);
    const products = computed(() => store.state.products);
    const loading = ref(false);
    const participantProducts = ref({
      allowedProducts: [],
      limitedProducts: [],
      selectedProducts: {
        allowed: [],
        limited: []
      }
    });

    const customerAllowedProducts = computed(() => (props.customer.allowed_products || []).filter(ap => ap.status === 'ACCEPTED'));

    const populateParticipantsProducts = () => {
      participantProducts.value.limitedProducts = [];
      participantProducts.value.allowedProducts = [];
      if (props.customer && props.customer.allowed_products) {
        (customerAllowedProducts.value || []).filter(p => {
          const product = products.value.find(prod => prod.uuid === p.product_uuid);
          if (product) {
            participantProducts.value.allowedProducts.push(product);
          }
        });

        participantProducts.value.limitedProducts = products.value.filter(p => !customerAllowedProducts.value.find(ap => ap.product_uuid === p.uuid));

        return;
      }

      participantProducts.value.limitedProducts = products.value;
    };

    watch(() => props.costumer, () => {
      populateParticipantsProducts();
    });

    onBeforeMount(async () => {
      loading.value = true;

      if (!store.state.isLazyLoaded.products) {
        await store.dispatch('getProducts');
      }

      populateParticipantsProducts();

      loading.value = false;
    });

    const updateCostumerObject = async () => {
      loading.value = true;
      const customerToUpdate = { ...props.customer };

      customerToUpdate.allowed_products = participantProducts.value.allowedProducts.map(p => ({
        product_uuid: p.uuid,
        horanet_product_code: null
      }));

      customerToUpdate.allowed_products = participantProducts.value.allowedProducts.map(p => {
        const allowed = customerAllowedProducts.value.find(ap => ap.product_uuid === p.uuid);

        return {
          product_uuid: p.uuid,
          product_name: p.name,
          horanet_product_code: null,
          updated_at: allowed && allowed.updated_at ? allowed.updated_at : format(new Date(), 'yyyy-MM-dd')
        };
      });

      (props.customer.allowed_products || []).map(ap => {
        if (!products.value.some(p => p.uuid === ap.product_uuid)) {
          customerToUpdate.allowed_products.push({
            product_uuid: ap.product_uuid,
            product_name: ap.product_name,
            horanet_product_code: null,
            updated_at: ap.updated_at
          });
        }
      });

      // create endpoint on api
      const response = await updateCustomerAllowedProduct(customerToUpdate.uuid, customerToUpdate.allowed_products);

      const notification = { type: 'error', message: 'Erreur lors de la mise à jour du client' };

      if (response.success) {
        notification.type = 'success';
        notification.message = 'Client mis à jour avec succès';
      }

      sendNotification(notification.type, notification.message);
      loading.value = false;
    };

    const swapProducts = () => {
      let indexToRemove = [];

      participantProducts.value.selectedProducts.allowed.map(p => {
        participantProducts.value.limitedProducts.push(p);

        const index = participantProducts.value.allowedProducts.findIndex(ap => ap.uuid === p.uuid);

        if (index !== -1) {
          indexToRemove.push(index);
        }
      });

      indexToRemove = indexToRemove.sort((a, b) => (a < b ? -1 : 1));

      for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
        participantProducts.value.allowedProducts.splice(indexToRemove[i], 1);
      }

      indexToRemove = [];

      participantProducts.value.selectedProducts.limited.map(p => {
        participantProducts.value.allowedProducts.push(p);

        const index = participantProducts.value.limitedProducts.findIndex(ap => ap.uuid === p.uuid);

        if (index !== -1) {
          indexToRemove.push(index);
        }
      });

      indexToRemove = indexToRemove.sort((a, b) => (a < b ? -1 : 1));

      for (let i = indexToRemove.length - 1; i >= 0; i -= 1) {
        participantProducts.value.limitedProducts.splice(indexToRemove[i], 1);
      }

      participantProducts.value.selectedProducts = {
        allowed: [],
        limited: []
      };

      // update Costumer
      updateCostumerObject();
    };

    const updateCustomerProduct = (product_uuid, elementType) => {
      const product = products.value.find(p => p.uuid === product_uuid);
      participantProducts.value[elementType].push(product);

      const elementToRemove = elementType === 'limitedProducts' ? 'allowedProducts' : 'limitedProducts';

      const index = participantProducts.value[elementToRemove].findIndex(p => p.uuid === product_uuid);

      if (index !== -1) {
        participantProducts.value[elementToRemove].splice(index, 1);
      }

      // update costumer
      updateCostumerObject();
    };

    const updateSelectedProducts = (typeToUpdate, product, action) => {
      if (action === 'add') {
        participantProducts.value.selectedProducts[typeToUpdate].push(product);
        return;
      }
      const index = participantProducts.value.selectedProducts[typeToUpdate].findIndex(p => p.uuid === product.uuid);

      if (index !== -1) {
        participantProducts.value.selectedProducts[typeToUpdate].splice(index, 1);
      }
    };

    provide('updateCustomerProduct', updateCustomerProduct);
    provide('updateSelectedProducts', updateSelectedProducts);

    return { products, loading, participantProducts, swapProducts };
  }
};
</script>
